"use client";

// Keyboard for a title screen: on the splash any key opens the menu; in the menu the arrow
// keys move between items marked `data-menu-item` and Escape goes back. Buttons and links
// do the rest, so Tab and Enter work as on any page.
import { c as _c } from "react/compiler-runtime";
import { useEffect, type RefObject } from "react";
export function useMenuKeys(options) {
  const $ = _c(7);
  const {
    enabled,
    splash,
    menuRef,
    openMenu,
    back
  } = options;
  let t0;
  let t1;
  if ($[0] !== back || $[1] !== enabled || $[2] !== menuRef || $[3] !== openMenu || $[4] !== splash) {
    t0 = () => {
      if (!enabled) {
        return;
      }
      const onKey = e => {
        if (e.metaKey || e.ctrlKey || e.altKey) {
          return;
        }
        if (splash) {
          if (e.key === "Tab" || document.activeElement instanceof HTMLAnchorElement) {
            return;
          }
          e.preventDefault();
          openMenu();
          return;
        }
        if (e.key === "Escape") {
          e.preventDefault();
          back();
          return;
        }
        if (e.key !== "ArrowDown" && e.key !== "ArrowUp") {
          return;
        }
        const items = [...(menuRef.current?.querySelectorAll("[data-menu-item]") ?? [])];
        if (!items.length) {
          return;
        }
        e.preventDefault();
        const at = items.indexOf(document.activeElement as HTMLElement);
        const step = e.key === "ArrowDown" ? 1 : -1;
        items[(at + step + items.length) % items.length].focus();
      };
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    };
    t1 = [enabled, splash, menuRef, openMenu, back];
    $[0] = back;
    $[1] = enabled;
    $[2] = menuRef;
    $[3] = openMenu;
    $[4] = splash;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
}